export default __webpack_public_path__ + "static/media/vietnam_icon.661e8c9c.svg";